<template>
  <b-card title="ผลการค้นหา">
    <slot></slot>

    <!-- <vue-excel-xlsx
      :data="rows"
      :columns="columnsExport"
      :file-name="'complaint_export'"
      :file-type="'xlsx'"
      :sheet-name="'sheetname'"
    >
      Download
    </vue-excel-xlsx> -->

    <div v-if="isGroup !== true" class="d-flex justify-content-start">
      <div
        v-if="totalRecords > 0 && searchMode !== 'ScreeningGroup'"
        class="d-flex justify-content-start"
      >
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Export ข้อมูล</label>
            <vue-select
              label="text"
              :required="true"
              v-model="exportPage"
              :options="exportPages"
              :clearable="false"
              @input="selectOnInput"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
        <div class="d-flex align-items-start ml-1">
          <JsonExcel
            class="btn btn-outline-primary"
            :fetch="fetchData"
            :fields="columnsExport"
            :before-generate="startDownload"
            :before-finish="finishDownload"
            :name="exportFileName"
          >
            Export Data
          </JsonExcel>
        </div>
      </div>
    </div>

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group> -->
      <!-- <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- <div v-if="isHighlightModeEnable()" class="d-flex justify-content-end mb-1">
      <span class="rounded-circle border row-red-example mr-1"></span>
      เรื่องที่เลยกำหนดการ Sla
      <span class="ml-1 mr-1"> | </span>
      <span class="rounded-circle border row-yellow-example mr-1"></span>
      เรื่องที่ยังไม่ได้เปิดอ่าน
    </div> -->

    <!-- table -->
    <vue-good-table
      ref="table-center"
      :columns="columns"
      :rows="rows"
      :row-style-class="rowStyleClassFn"
      @on-row-click="onRowClick"
      @on-selected-rows-change="selectionChanged"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: isOption,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Start ComplaintColumn -->
        <!-- #region Complaint -->

        <span v-if="props.column.field === 'complaintCode'" class="text-nowrap">
          <span class="text-nowrap"
            >{{ props.row.complaintCode }}
            <FastTrackIcon
              v-if="props.row.isMouCompany == true"
              :isMouCompany="props.row.isMouCompany"
              :isAllowFastTrack="props.row.isAllowFastTrack"
            />
            <!-- <feather-icon
              icon="StarIcon"
              class="mr-50 text-warning"
              v-if="props.row.isMouCompany == true"
            />

            <feather-icon
              icon="CheckSquareIcon"
              class="mr-50 text-success"
              v-if="props.row.isAllowFastTrack == true"
            /> -->
          </span>
          <br
            v-if="
              props.row.sarabunCode !== null &&
                props.row.sarabunCode !== undefined &&
                props.row.sarabunCode !== ''
            "
          />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.sarabunCode }}</span
          >
          <br
            v-if="
              props.row.provinceName !== null &&
                props.row.provinceName !== undefined &&
                props.row.provinceName !== ''
            "
          />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.provinceName }}</span
          >
          <br
            v-if="
              props.row.districtName !== null &&
                props.row.districtName !== undefined &&
                props.row.districtName !== ''
            "
          />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.districtName }}</span
          >
        </span>

        <span v-if="props.column.field === 'complaintDate'" class="text-nowrap">
          <span v-if="props.row.channelId === 39">
            <span class="text-nowrap">{{
              props.row.regionComplaintDateStr
            }}</span>
          </span>
          <span v-else>
            <span class="text-nowrap">{{ props.row.complaintDateStr }}</span>
          </span>
          <!-- <span class="text-nowrap">{{ props.row.complaintDateStr }}</span> -->
          <br />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.channelName }}</span
          >
          <br v-if="props.row.isDisplaySenderDepartmentName === true" />
          <span
            v-if="
              props.row.isDisplaySenderDepartmentName === true &&
                props.row.departmentSenderName !== null
            "
            v-b-tooltip.hover
            :title="props.row.departmentSenderName"
            class="text-nowrap"
          >
            {{
              props.row.departmentSenderName.length > 25
                ? props.row.departmentSenderName.substring(0, 25)
                : props.row.departmentSenderName
            }}{{ props.row.departmentSenderName.length >= 25 ? "..." : "" }}
          </span>
        </span>

        <!-- Column: Name -->
        <span v-if="props.column.field === 'companyName'" class="text-nowrap">
          <!-- <span
            v-for="(item, index) in props.row.companyNameList"
            class="text-nowarp"
            v-b-tooltip.hover
            :key="index"
            :title="item"
          >
            <feather-icon icon="BriefcaseIcon" class="mr-50" />
            {{ item.substring(0, 50) }}{{ item.length >= 50 ? "..." : "" }}
            <br />
          </span> -->
          <span class="text-nowarp" v-if="isShowCompanyName(props.row.cusname)">
            <feather-icon icon="BriefcaseIcon" class="mr-50" />
            <b
              v-if="
                props.row.companyName !== null &&
                  props.row.companyName !== undefined
              "
            >
              {{ props.row.companyName.substring(0, 50)
              }}{{ props.row.companyName.length >= 50 ? "..." : "" }}
            </b>

            <br />
          </span>

          <span
            v-for="(item, index) in getComplainantCompany(props.row.cusname)"
            :key="item.timeStamp"
            class="text-nowarp"
          >
            <feather-icon
              v-if="item.type == '3'"
              icon="UserIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '8'"
              icon="UsersIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '476'"
              icon="BriefcaseIcon"
              class="mr-50"
            />
            <span v-else></span
            ><b>
              {{ item.text.substring(0, 50)
              }}{{ item.text.length >= 50 ? "..." : "" }}</b
            >
            <br />
          </span>

          <span
            v-for="(item, index) in props.row.complainantJsonList.filter(
              function(value) {
                return value.role === 3;
              },
            )"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon icon="UserIcon" class="mr-50" />{{ item.fName }}
            {{ item.lName }}
            <br />
          </span>

          <span
            v-for="(item, index) in props.row.complainantJsonList.filter(
              function(value) {
                return value.role === 8;
              },
            )"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon icon="UsersIcon" class="mr-50" />{{ item.fName }}
            {{ item.lName }}
            <br />
          </span>

          <span
            v-for="(item, index) in getComplainantUser(props.row.cusname)"
            :key="index"
            class="text-nowarp"
          >
            <feather-icon
              v-if="item.type == '3'"
              icon="UserIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '8'"
              icon="UsersIcon"
              class="mr-50"
            />
            <feather-icon
              v-else-if="item.type == '476'"
              icon="BriefcaseIcon"
              class="mr-50"
            />
            <span v-else></span>{{ item.text.substring(0, 50)
            }}{{ item.text.length >= 50 ? "..." : "" }}
            <br />
          </span>

          <!-- <span class="text-nowarp">
            <feather-icon icon="UserIcon" class="mr-50" />
            {{ props.row.cusname }}
          </span> -->
        </span>

        <span v-if="props.column.field === 'operatorName'" class="text-nowrap">
          <span class="text-nowrap"
            >{{ props.row.departmentName }} /<br />
            {{ props.row.name }}</span
          >
        </span>

        <span
          v-if="props.column.field === 'onFastTrackStatus'"
          class="text-nowrap"
        >
          <span class="text-nowrap"
            >{{ props.row.onFastTrackStatus }}
            {{
              props.row.onFastTrack ? `(${props.row.fastTrackSlaCount})` : ""
            }}</span
          >
        </span>

        <span
          v-if="props.column.field === 'operatorNameBangkok'"
          class="text-nowrap"
        >
          <span class="text-nowrap"
            >{{ props.row.departmentName }} {{ props.row.districtName }} /<br />
            {{ props.row.name }}</span
          >
        </span>

        <!-- Column: Complain_Subject -->
        <span v-if="props.column.field === 'status'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.updateTrackingStr }} ({{ props.row.awaitDay }}) /
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.leveldescription }}-{{ props.row.statusdescription }} /
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.complaintGroupCode }}
          </span>
          <br />
          <!-- <span v-if="props.row.name !== null && props.row.name !== undefined" class="text-nowarp"> คุณ {{ props.row.name }} </span> -->
        </span>

        <span v-if="props.column.field === 'complaintForm'" class="text-nowrap">
          <b
            v-if="props.row.documentTrackingDetails.length > 0"
            class="text-nowrap"
          >
            <b
              v-for="(item, key) in props.row.documentTrackingDetails"
              :key="key"
            >
              {{ item.description }}({{ item.awaitDay }})
              <br />
            </b>
          </b>
          <b v-else> - </b>
          /
          <b v-if="props.row.complaintFileType3.length > 0" class="text-nowrap">
            <b v-for="(item, key) in props.row.complaintFileType3" :key="key">
              {{ excludeFileExtension(item.title) }}({{ item.awaitDay }})
              <br />
            </b>
          </b>
          <b v-else> - </b>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item
                @click="onComplainGroupManage(props.row.complaintId)"
              >
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>ดูรายละเอียด</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="onComplaintFormClicked(props.row.complaintId)"
              >
                <feather-icon icon="FileTextIcon" class="mr-50" />
                <span>ใบคำขอร้องทุกข์</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- #endregion -->

        <!-- Start ComplaintGroupColumn -->
        <!-- #region ComplaintGroup -->

        <!-- Column: groupCreateDate -->
        <span
          v-if="props.column.field === 'groupCreateDate'"
          class="text-nowrap"
        >
          <span class="text-nowrap">
            {{ props.row.complaintGroupCode }}
          </span>
          <br />
          <span class="text-nowrap">
            {{ props.row.createDateStr }}
          </span>
        </span>

        <!-- Column: groupCompanyName -->
        <span
          v-if="props.column.field === 'groupCompanyName'"
          class="text-nowrap"
        >
          <span
            v-for="(item, index) in getGroupCompany(props.row.companyName)"
            :key="item.timeStamp"
            class="text-nowarp"
          >
            <feather-icon icon="BriefcaseIcon" class="mr-50" />
            <b>
              {{ item.text.substring(0, 50)
              }}{{ item.text.length >= 50 ? "..." : "" }}</b
            >
            <br />
          </span>
        </span>

        <!-- Column: groupIssue -->
        <span v-if="props.column.field === 'groupIssue'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.complaintDetail }}
          </span>
        </span>

        <!-- Column: groupCreateBy -->
        <span v-if="props.column.field === 'groupCreateBy'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.groupCreateBy }}
          </span>
        </span>

        <!-- Column: groupStatus -->
        <span v-if="props.column.field === 'groupStatus'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.updateDateStr }}
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.leveldescription }}-{{ props.row.statusdescription }}
          </span>
          <br />
          <!-- <span v-if="props.row.name !== null && props.row.name !== undefined" class="text-nowarp"> คุณ {{ props.row.name }} </span> -->
        </span>

        <!-- Column: groupOperatorName -->
        <span
          v-if="props.column.field === 'groupOperatorName'"
          class="text-nowrap"
        >
          <span class="text-nowrap"
            >{{ props.row.departmentName }} /<br />
            {{ props.row.officerName }}</span
          >
        </span>

        <!-- #endregion -->

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              limit="8"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
//import VueExcelXlsx from "vue-excel-xlsx";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import appsettings from "@/store/app-settings";
import { searchAdapter, getSearchMethod } from "./searchAdapter.js";
//import XLSX from "xlsx";
import JsonExcel from "vue-json-excel";
import VueSelect from "vue-select";

import commonTableExportHeader from "./commonTableExportHeader.js";
import FastTrackIcon from "../FastTrack/FastTrackIcon.vue";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    JsonExcel,
    VueSelect,
    FastTrackIcon,
  },
  props: {
    routeName: String,
    tableHeader: [],
    searchMode: null,
    isOption: false,
    isGroup: false,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: this.tableHeader,
      rows: [],
      searchTerm: "",
      totalRecords: 0,
      params: {},
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      columnsExport: commonTableExportHeader,
      exportPage: { value: 1, text: "" },
      exportPages: [],
      exportPerPage: 1000,
      exportFileName: "Complaint.xls",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true;
        return this.dir;
      }
      this.dir = false;
      return this.dir;
    },
  },
  methods: {
    searchAdapter,
    onRowClick(params) {
      console.log("onRowClick", params);

      if (params.row.cpGroupId) {
        console.log("onRowClick - ตัวกลุ่ม", this.searchMode);
        this.$emit("handleGroup", params.row.cpGroupId); // ตัวกลุ่ม
      } else {
        // console.log("onRowClick", params.row.refComplaintGroupId);
        if (
          params.row.refComplaintGroupId !== undefined &&
          params.row.refComplaintGroupId !== null
        ) {
          console.log("onRowClick - เรื่องภายในกลุ่ม", this.searchMode);
          if (
            this.searchMode === "Screening" ||
            this.searchMode === "Officer" ||
            this.searchMode === "LawOfficer"
          ) {
            this.$emit("handleGroup", params.row.refComplaintGroupId, true); //  เรื่องภายในกลุ่ม
          } else {
            this.$emit("handleGroup", params.row.complaintId); // เรื่องที่ไม่อยู่ในกลุ่ม
          }
        } else {
          console.log("onRowClick - เรื่องที่ไม่อยู่ในกลุ่ม", this.searchMode);
          this.$emit("handleGroup", params.row.complaintId); // เรื่องที่ไม่อยู่ในกลุ่ม
        }
      }
    },
    onComplainGroupManage(id) {
      this.$emit("handleGroup", id);
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      console.log("onSearchSubmit vueGoodTable", params);
      this.params = params;
      params.page = page.currentPage;
      params.perPage = this.pageLength;

      this.searchAdapter(this, params);
    },
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params);
    },
    onComplaintFormClicked(id) {
      const url = appsettings.complaintFormUrl.replace("{0}", id);
      window.open(url, "_blank");
    },
    async fetchData() {
      let exportParams = this.params;
      exportParams.page = this.exportPage.value;
      exportParams.perPage = this.exportPerPage;
      this.exportFileName = "Complaint (" + this.exportPage.text + ").xls";

      let searchMethod = getSearchMethod(this.searchMode);

      const response = await searchMethod(exportParams);
      console.log("fetchData response", response);
      return response.data.data;
    },
    startDownload() {
      this.$emit("handleOverlay", true);
    },
    finishDownload() {
      this.$emit("handleOverlay", false);
    },
    getExportPages() {
      this.exportPages = [];
      for (let i = 0; i < this.totalRecords / this.exportPerPage; i++) {
        this.exportPages.push({
          value: i + 1,
          text:
            i * this.exportPerPage +
            1 +
            " - " +
            ((i + 1) * this.exportPerPage > this.totalRecords
              ? this.totalRecords
              : (i + 1) * this.exportPerPage),
        });
      }

      if (this.exportPages.length > 0) {
        this.exportPage = this.exportPages[0];
      }
    },
    rowStyleClassFn(row) {
      if (this.isHighlightModeEnable()) {
        return "";
        if (row.slaStart !== null && row.slaAlert !== null) {
          if (row.isSlaOverdue === true) {
            return "row-red";
          }
        }

        if (
          this.searchMode === "Officer" ||
          this.searchMode === "LawOfficer" ||
          this.searchMode === "Screening"
        ) {
          if (row.readDate === null) {
            return "row-yellow";
          }
        } else if (
          this.searchMode === "Deptlist" ||
          this.searchMode === "LawDeptlist"
        ) {
          if (row.recieveDate === null) {
            return "row-yellow";
          }
        }
      }

      return "";
    },
    isHighlightModeEnable() {
      if (
        this.searchMode === "Officer" ||
        this.searchMode === "LawOfficer" ||
        this.searchMode === "Screening" ||
        this.searchMode === "Deptlist" ||
        this.searchMode === "LawDeptlist"
      ) {
        return true;
      }
      return false;
    },
    isShowCompanyName(cusname) {
      try {
        let complainantList = this.getComplainantList(cusname);

        let company = complainantList.find((value) => value.type === "476");

        //console.log('complainantList', complainantList, company)

        if (company !== null && company !== undefined) {
          //console.log('return false')
          return false;
        }
        //console.log('return true')
        return true;
      } catch (ex) {
        return true;
      }
    },
    getComplainantCompany(cusname) {
      try {
        let complainantList = this.getComplainantList(cusname);

        let companies = complainantList.filter(function(value) {
          value.timeStamp = Date.now() + Math.random();
          return value.type === "476";
        });

        //console.log("companies", companies);

        return companies;
      } catch (ex) {
        return [];
      }
    },
    getComplainantUser(cusname) {
      try {
        let complainantList = this.getComplainantList(cusname);

        let users = complainantList.filter(function(value) {
          return value.type !== "476";
        });

        return users;
      } catch (ex) {
        return [];
      }
    },
    getComplainantList(cusname) {
      try {
        let records = cusname.split(",");

        let results = [];

        records.forEach((value) => {
          try {
            //console.log("propValue", value);

            let propSplit = value.split(":");

            let propObj = {};

            if (propSplit[0] !== null && propSplit[0] !== undefined) {
              propObj.type = propSplit[0];
            }

            if (propSplit[1] !== null && propSplit[1] !== undefined) {
              propObj.text = propSplit[1];
            } else {
              propObj.text = "";
            }

            results.push(propObj);
          } catch (ex) {
            console.log("prop split ex", ex);
          }
        });

        return results;
      } catch (ex) {
        return [];
      }
    },
    excludeFileExtension(name) {
      try {
        return name
          .split(".")
          .slice(0, -1)
          .join(".");
      } catch (ex) {
        return name;
      }
    },
    getGroupCompany(companyNames) {
      try {
        let records = companyNames.split("\n");
        let companies = records.map(function(value) {
          let companyObject = {
            timeStamp: Date.now() + Math.random(),
            text: value,
          };
          return companyObject;
        });

        //console.log("companies", companies);

        return companies;
      } catch (ex) {
        return [];
      }
    },
    selectOnInput() {
      console.log("on input");
      this.$forceUpdate();
    },
    selectionChanged() {
      console.log("ref", this.$refs);
      this.$emit("handle-select", this.$refs["table-center"].selectedRows);
    },
  },
};
</script>

<style></style>
